"use strict";
// packages/types/src/activity.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityType = void 0;
var ActivityType;
(function (ActivityType) {
    ActivityType["AUTH"] = "AUTH";
    ActivityType["USER"] = "USER";
    ActivityType["ORGANISATION"] = "ORGANISATION";
    ActivityType["TEAM_MEMBER"] = "TEAM_MEMBER";
    ActivityType["PLAN"] = "PLAN";
    ActivityType["RECORD"] = "RECORD";
    ActivityType["AUDIT"] = "AUDIT";
    ActivityType["RELEASE"] = "RELEASE";
    ActivityType["INVITATION"] = "INVITATION";
    ActivityType["SUBSCRIPTION"] = "SUBSCRIPTION";
    ActivityType["OTHER"] = "OTHER";
})(ActivityType || (exports.ActivityType = ActivityType = {}));
